const SettingItem = ({ label, description, children }) => {
  return (
    <div className="py-3 md:py-4 first:pt-0 last:pb-0">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <div className="flex-1">
          <label className="text-sm md:text-base font-medium text-foreground block mb-1">
            {label}
          </label>
          {description && (
            <p className="text-xs md:text-sm text-muted-foreground">
              {description}
            </p>
          )}
        </div>
        <div className="flex-shrink-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingItem;